let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gYi9E")).then(() => parcelRequire('6Betp'));